import { withoutVersionService } from './request';

const WechatCenter = withoutVersionService('wechat');

export default {
  //获取JS_SDK的参数
  getJsParam: WechatCenter('get', 'jsApi/getJsParam'),
  //通过code获取微信号信息
  authorizeUser: WechatCenter('get', 'authorize/user'),
  //获取微信支付参数
  getPayParam: WechatCenter('get', 'pay/getParam'),

  //获取支付参数
  getParam4Mini: WechatCenter('get', 'pay/getParam4Mini'),

  //获取微信支付参数不需要payCode
  getPayParam4Group: WechatCenter('get', 'pay/getParam4Group'),
  //支付宝获取获取用户信息
  aliUser: WechatCenter('get', 'aliAuth/user'),

  //支付宝授权接口
  aliAuthorize: WechatCenter('get', 'aliAuth/forward'),
  //微信授权
  wxAuthorize: WechatCenter('get', 'authorize/forward'),

  //QQ授权接口
  qqAuthorize: WechatCenter('get', 'qqAuth/forward'),
  //qq获取获取用户信息
  qqAuthorizeUser: WechatCenter('get', 'qqAuth/user'),

  wxAuthorizeRedirect: WechatCenter('get', 'component/wxAuthorizeRedirect'),

  //抖音授权相关
  douyinUser: WechatCenter('get', 'douyinAuth/user'),
  //获取抖音授权相关params
  getDouyinParam: WechatCenter('get', 'douyinAuth/getDouyinParam'),

  //获取临时用户
  getTempUserByLocalCode: WechatCenter('get', 'authorize/getTempUserByLocalCode'),

  //根据localCode获取真实用户信息
  getUserByLocalCode: WechatCenter('get', 'authorize/getUserByLocalCode'),

  // H5支付获取 MWEB_URL
  getH5PayUrm: WechatCenter('get', 'pay/getParam4H5')
};
